// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tag-badge[data-v-dc85337a]{color:#fff;border-radius:50px;padding:.5rem 1rem;font-size:14px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
